/*
* @描述: 跟进记录详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-11 15:16:43
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               class="custom_form_dialog custom-form-dialog"
               title="跟进记录详情"
               width="520px">
        <div v-loading="loading" class="custom_form_body">
            <CustomFormDetailPc :field_list="formInfoList"
                                v-if="dataLoaded"
                                :form_detail="formDetailData"
                                :pk_id="record_id"/>
        </div>
    </el-dialog>
</template>
<script>
    import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
    import {getFormFields, customerPrivateFollowUpDetail} from "@/api";

    export default {
        name: "fOLLowUpAdd",
        data() {
            return {
                formInfoList: [],
                formDetailData: {},
                dataLoaded: false,
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            record_id: {
                type: Number,
                default: 0
            }
        },
        components: {CustomFormDetailPc},
        created() {
            this._getFromFields()
        },
        methods: {
            _getFromFields() {
                this.loading = true
                getFormFields({
                    field_form: 'customer_follow_ups'
                }).then(res => {
                    if (res.code === 200) {
                        this.formInfoList = res.data
                        customerPrivateFollowUpDetail(this.record_id).then(res => {
                            if (res.code === 200) {
                                this.formDetailData = res.data
                                this.loading = false
                                this.dataLoaded = true
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            },

            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },
        },
    }
</script>
<style lang="scss" scoped>
    .custom_form_body {
        height: 470px;
        padding: 24px;

        .page_little_title {
            margin-top: 16px;
        }
    }
</style>